import React from "react";
import InvestorList from "./investors/investor_list";

function InvestorComponent(props) {
  return <InvestorList {...props} />;
}

export default InvestorComponent;
